<script>
import ArchiveBase from "@/components/base_components/ArchiveBase";
import CarsService from "@/store/services/cars.service";

export default {
  name: "CarArchive",
  extends: ArchiveBase,
  methods: {
    extendable() {
      let vm = this;

      this.swapState();

      CarsService.archive(this.item.id, {value: this.is_archived}).catch(function(response) {
        vm.swapState();
        if (response.status === 403) {
          vm.$store.commit('setAlert', {
            title: vm.$gettext("Error editing the car"),
            text: vm.$gettext("You do not have permissions to add a new car."),
            variant: "error",
            duration: 4
          });
        } else {
          vm.$store.commit('setAlert', {
            title: vm.$gettext("Error archiving the car"),
            text: vm.$gettext("Something went wrong..."),
            variant: "error",
            duration: 4
          });
        }

      });
    },
    canArchive() {

      return true;
    }
  }
}
</script>